jQuery(document).ready(function($) {

  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    // console.log(urlParams.get(name));
    return urlParams.get(name);
  }
  
  var variant = getUrlParameter('variant');
  console.log("PDP URL is:" + variant);

  var product_title1 = $(".product__title").html();
  var product_title = product_title1.trim();
  
  var product_value = $(this).attr("data-swatch"); // get the value of product swatch.
  $('.custom_var_des_detail').removeClass('activated');
  
  if (!variant || variant === "") {
    $('.custom_var_des_detail').first().show().addClass('activated');
  } 
  else {
    $('.custom_var_des_detail').each(function(i, e) {
      let option_val = $(this).attr('data-variant-id');
      if (variant == option_val) {
        $(this).show().addClass('activated');
        return false;
      }
    });
  }


  

  $( ".swatch__button label" ).on('click', function() {

    var product_value = $(this).attr("data-swatch"); // get the value of product swatch.
    var product_value2 = product_title + " - " + product_value; 

    setTimeout(function() {
      var GetURL = getUrlParameter('variant');
      console.log("PDP URL is:" + GetURL);

      var product_title1 = $(".product__title").html();
      var product_title = product_title1.trim();
      
        

      $('.custom_var_des_detail').removeClass('activated');
      $('.custom_var_des_detail').each(function(i, e) {
          let option_val = $(this).attr('data-variant-id');
          console.log("Selected URL is:" + option_val);
          if (option_val.includes(GetURL)) {
            $(this).show().addClass('activated');
            return false;
          }
      });
    }, 1000);
      
      for (i = 1; i <=100; i++) {

        // desktop verion
        const thumbnails_value = $(".custom_thumbnail" + [i]).attr("aria-label");
        const tt = thumbnails_value;
        const ttt = tt[1];
        
        if( thumbnails_value == product_value || ttt == product_value) {
          $(".custom_thumbnail" + [i]).addClass("show_product_image");
          $(".custom_thumbnail" + [i]).removeClass("hide_product_image");
        }
        else {
          $(".custom_thumbnail" + [i]).removeClass("show_product_image");
          $(".custom_thumbnail" + [i]).addClass("hide_product_image");
        }
      } 
    
    
  });

});


document.addEventListener('DOMContentLoaded', function () {

    const checkForElements = setInterval(function() {
    const colorSwatches = document.querySelectorAll('.custom-switch-color');
    if (colorSwatches.length > 0) {
      // Update the color name when hovering over a swatch
      colorSwatches.forEach(swatch => {
        // Update the color name when a swatch is selected (click event)
        swatch.addEventListener('click', function (e) {
          let pid = e.target.getAttribute('data-product-id');
          let sid = e.target.getAttribute('data-section-id');
          currentColorName = swatch.getAttribute('data-swatch');
          let vid = e.target.getAttribute('data-swatch-variant');
          
          // find swatch name display element
          const colorSwatchNameDisplays = document.querySelectorAll('.color-swatch-name');
          let parentElement = findElementofSwatchName(colorSwatchNameDisplays, pid, sid);
          if ( parentElement ) {
            parentElement.querySelector('span').textContent = currentColorName;
            parentElement.classList.remove('invisiable');
          }

          // find the Choose color button and replace it with ADD to Bag when it is clicked.
          let selectedHasSwatchbtn = null;
          const hasSwatchbtns = document.querySelectorAll('#has_swatch_btn');
          if ( hasSwatchbtns ) {
            selectedHasSwatchbtn = findElementofSwatchName(hasSwatchbtns, pid, sid)
          }
          selectedHasSwatchbtn.querySelector('span.custom-swatch-choose').textContent = "ADD TO BAG";

          // find the variant input field according pid, sid
          const variantInputFields = document.querySelectorAll('.variant-id-class');
          let matchedVariantInputField = null;
          if ( variantInputFields ) {
            matchedVariantInputField = findElementofSwatchName(variantInputFields, pid, sid);
          }
          console.log(matchedVariantInputField, vid, pid, sid);
          matchedVariantInputField.value = vid;

          // find the swathces group of same product id and section id, not all swatches
          let sameSwatchesGroup = findSameSwatchs(colorSwatches, pid, sid);
          // Remove 'selected' class from all swatches
          // colorSwatches.forEach(s => s.classList.remove('selected'));
          sameSwatchesGroup.forEach(s => s.classList.remove('selected'));
          // Add 'selected' class to the clicked swatch
          swatch.classList.add('selected');
        });
      });
      // Once elements are found and event listeners are added, stop the polling
      clearInterval(checkForElements);
    }

    // open mini-cart modal function when has swatches and selects. warning select a color msg
    const swatchButtons = document.querySelectorAll('#has_swatch_btn');
    if ( swatchButtons.length > 0 ) {
      swatchButtons.forEach(swatchBtn => {
        swatchBtn.addEventListener('click', function(e) {
          if ( swatchBtn.querySelector('span.custom-swatch-choose').textContent == "ADD TO BAG" ) {

            e.preventDefault();
            epid = e.target.getAttribute('data-product-id');
            esid = e.target.getAttribute('data-section-id');

            // find the variant input field according pid, sid
            const evariantInputFields = document.querySelectorAll('.variant-id-class');
            let ematchedVariantInputField = null;
            if ( evariantInputFields ) {
              ematchedVariantInputField = findElementofSwatchName(evariantInputFields, epid, esid);
            }

            let productId = ematchedVariantInputField.value;
            console.log('clicked', productId);

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log("Item added to cart:", data);
                
                // Trigger the mini-cart drawer
                let cartDrawer = document.querySelector("cart-drawer") || document.querySelector(".cart-popup-wrapper");
                if (cartDrawer) {
                    cartDrawer.classList.add("open"); // Adjust class based on your theme's modal behavior
                }
            })
            .catch(error => console.error("Error adding to cart:", error));

          } else {

            let bpid = e.target.getAttribute('data-product-id');
            let bsid = e.target.getAttribute('data-section-id');
            const BcolorSwatchNameDisplays = document.querySelectorAll('.color-swatch-name');
            let BparentElement = findElementofSwatchName(BcolorSwatchNameDisplays, bpid, bsid);
            if ( BparentElement ) {
              BparentElement.querySelector('span').textContent = "Please Select a Color";
              BparentElement.classList.remove('invisiable');
            }

            e.preventDefault();

          }
          
        });
      })
    }
    // open mini-cart modal function when has swatches and selects. warning select a color msg

    // + and - span button function for show and less swatches
    const swatchToggleBtn = document.querySelectorAll('.swatch-toggle-btn');
    const colorSwatchesContainers = document.querySelectorAll('#custom-swatch-containers');
    if ( swatchToggleBtn.length > 0) {
      swatchToggleBtn.forEach(stogglebtn => {
        stogglebtn.addEventListener('click', function(e) {
          console.log('Clicked Toggle BTN', e.target, stogglebtn.textContent);

          if ( stogglebtn.textContent.trim() == "+" ) {
            let tpid = e.target.getAttribute('data-product-id');
            let tsid = e.target.getAttribute('data-section-id');
            const matchedSwatches = findSameSwatchs(colorSwatchesContainers, tpid, tsid);
            matchedSwatches.forEach(colSwatch => {
              colSwatch.style.display = 'inline-block';
            })

            stogglebtn.textContent = "-";
          } else {
            let tpid = e.target.getAttribute('data-product-id');
            let tsid = e.target.getAttribute('data-section-id');
            const matchedSwatches = findSameSwatchs(colorSwatchesContainers, tpid, tsid);
            let maxSwatchCount = 5;
            matchedSwatches.forEach((colSwatch, index) => {
              if ( index >= maxSwatchCount ) {
                colSwatch.style.display = 'none';
              }

            })

            stogglebtn.textContent = "+";
            
          }
      })
    })
  }
  // + and - span button function for show and less swatches


  // add to bag custom button open - mini - cart
  document.querySelectorAll(".custom-add-to-bag").forEach(button => {

    button.addEventListener("click", function (e) {
        e.preventDefault();
        let productId = this.getAttribute("data-variant-id");
        console.log('clicked', productId);

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: productId,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log("Item added to cart:", data);
            
            // Trigger the mini-cart drawer
            let cartDrawer = document.querySelector("cart-drawer") || document.querySelector(".cart-popup-wrapper");
            if (cartDrawer) {
                cartDrawer.classList.add("open"); // Adjust class based on your theme's modal behavior
            }
        })
        .catch(error => console.error("Error adding to cart:", error));
    });
  });
  // add to bag custom button open - mini - cart

  }, 100); // Check every 100ms

  

});

function findElementofSwatchName(elements, pid, sid) {
  for (let i = 0; i < elements.length; i++) {
    const ele = elements[i];
    if (ele.getAttribute('data-product-id') == pid && ele.getAttribute('data-section-id') == sid) {
      return ele; // Exit the function immediately when found
    }
  }
  return null; // If no element is found, return null
}

function findSameSwatchs(elements, pid, sid) {
  let results = [];
  elements.forEach(ele => {
    if( ele.getAttribute('data-product-id') == pid && ele.getAttribute('data-section-id') == sid ) {
      results.push(ele);
    }
  });
  return results;
}

function updateMinHeight() {
  requestAnimationFrame(() => {
    let items = document.querySelectorAll(".product-grid-item");
    //find the same section items
    let mainSectionItems = [];
    let tabsSectionItems = [];
    let collection_split_sectionSectionItems = [];
    let relatedSectionItems = [];
    let product_gridSectionItems = [];
    let generalSectionItems = [];

    let mH_mainSectoinItems = 0;
    let mH_tabsSectionItems = 0;
    let mH_collection_split_sectionSectionItems = 0;
    let mH_relatedSectionItems = 0;
    let mH_product_gridSectionItems = 0;
    let mH_generalSectionItems = 0;

    // Reset height to auto to get natural height
    items.forEach(item => {
      item.style.minHeight = "auto"; 
      let sid = item.getAttribute('data-section-id');
      console.log(sid);
      if ( sid.includes('main') ) {
        mainSectionItems = findSameSectoinProdcutGridItems(items, sid)
      } else if ( sid.includes('tabs') ) {
        tabsSectionItems = findSameSectoinProdcutGridItems(items, sid)
      } else if ( sid.includes('collection-split-section') ) {
        collection_split_sectionSectionItems = findSameSectoinProdcutGridItems(items, sid)
      } else if ( sid.includes('related') ) {
        relatedSectionItems = findSameSectoinProdcutGridItems(items, sid)
      } else if ( sid.includes('product-grid') ) {
        product_gridSectionItems = findSameSectoinProdcutGridItems(items, sid)
      } else {
        generalSectionItems = findSameSectoinProdcutGridItems(items, sid)
      }


    });

    // Find max height according to each section
    mH_mainSectoinItems = findMaxHeight(mainSectionItems);
    mH_tabsSectionItems = findMaxHeight(tabsSectionItems);
    mH_collection_split_sectionSectionItems = findMaxHeight(collection_split_sectionSectionItems);
    mH_relatedSectionItems = findMaxHeight(relatedSectionItems);
    mH_product_gridSectionItems = findMaxHeight(product_gridSectionItems);
    mH_generalSectionItems = findMaxHeight(generalSectionItems);




    // Apply min-height based on section ID
    items.forEach(item => {
      let sectionId = item.getAttribute('data-section-id') || '';
      if (sectionId.includes('tabs') ) {
        item.style.minHeight = mH_tabsSectionItems + "px";
      } else if (sectionId.includes('collection-split-section')) {
        item.style.minHeight = mH_collection_split_sectionSectionItems + "px";
      } else if ( sectionId.includes('product-grid') ) {
        item.style.minHeight = mH_product_gridSectionItems + "px";
      } else if (sectionId.includes('related')  ) {
        item.style.minHeight = mH_relatedSectionItems + "px";
      } else if ( sectionId.includes('main') ) {
        item.style.minHeight = mH_mainSectoinItems + "px";
      } else {
        item.style.minHeight = mH_generalSectionItems + "px";
      }
    });
  });
}

function findMaxHeight(elements) {
  let maxHeight = 0;
  elements.forEach(item => {
    let itemHeight = item.getBoundingClientRect().height;
    if (itemHeight > maxHeight) {
      maxHeight = itemHeight;
    }
  });
  return maxHeight;
}

function findSameSectoinProdcutGridItems(elements, sid) {
  let results = [];
  elements.forEach(ele => {
    if( ele.getAttribute('data-section-id') == sid ) {
      results.push(ele);
    }
  });
  return results;
}

// Run function on page load and resize
window.addEventListener("load", updateMinHeight);
window.addEventListener("resize", updateMinHeight);




